import React from 'react';
import { isSafari } from 'react-device-detect';
import { shallowEqual } from 'react-redux';
import { useBooth } from '../../../../../hooks/useBooth';
import useMobileView from '../../../../../hooks/useMobileView';
import { useWindowSize } from '../../../../../hooks/useWindowSize';
import { Booth, Meetingroom } from '../../../../../interfaces/interfaces';
import { BoothsComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import SmallBooth from './SmallBooth';
interface BoothPopupProps {
  booth: Booth | undefined;
  trigger?: any;
  uiComponent?: BoothsComponentInterface;
}

export const BoothPopup = (props: BoothPopupProps) => {
  const { booth, uiComponent } = props;

  const event = useSelector((state) => state.common.event);
  const { openBooth, openBoothFromPBComponent } = useBooth();
  const { width } = useWindowSize();
  const { isMobileView } = useMobileView();

  const onlineStatuses = ['live', 'open', 'queue'];

  function convertToStatusObject(rooms?: Meetingroom[]): { [key: string]: 1 | 0 } {
    const output: { [key: string]: 1 | 0 } = {};

    if (rooms) {
      rooms.forEach((room) => {
        output[room._id] = onlineStatuses?.includes(room.displaystatus) ? 1 : 0;
      });
    }

    return output;
  }

  const roomStatuses = Object.assign(
    {},
    convertToStatusObject(booth?.meetingrooms),
    convertToStatusObject(booth?.conferencerooms),
    convertToStatusObject(booth?.presentationrooms)
  );

  const liveRoomStatus = useSelector(
    (state) => Object.entries(state.common.meetingroomStatuses)?.filter(([key, value]) => Object.keys(roomStatuses).includes(key)),
    shallowEqual
  );

  const isAnyRoomOnline = Object.entries(roomStatuses)
    .map(([key, value]) => {
      /**
       * We see if we have a live status that comes
       * in via pusher. If so, we use it.
       * Otherwise we reutnr the default value from the booth.
       */
      if (liveRoomStatus) {
        const liveStatus = liveRoomStatus.find(([k]) => k === key);
        if (liveStatus) return onlineStatuses.includes(liveStatus[1]) ? 1 : 0;
      }

      return value;
    })
    .some((value) => value === 1);

  if (!event) return <></>;

  return (
    <>
      <div
        onClick={() => {
          if (booth) {
            if (uiComponent) openBoothFromPBComponent(booth._id, uiComponent._id);
            else openBooth(booth._id);
          }
        }}
        id={`booth-${booth?._id}`}
        className="relative flex justify-center w-full cursor-pointer"
        style={{
          ...(isSafari ? { marginTop: '2.5rem', marginRight: '2.5rem' } : {}),
          ...(booth && width && width > 1200 && props.uiComponent?.spotlightBooths?.includes(booth?._id) && !isMobileView() ? { gridColumn: 'span 3' } : {}),
        }}>
        <SmallBooth
          event={event}
          uiComponent={props.uiComponent}
          spotlight={booth && props.uiComponent?.spotlightBooths?.includes(booth?._id)}
          booth={booth}
          showOnlineStatus={props.uiComponent?.highlightOnline && isAnyRoomOnline}
        />
      </div>
    </>
  );
};
